// This is just a placeholder component for the Auth0 callback route.
export const Callback = () => {
  return null
}
